import { CoreSearch } from '@komodo-design-system/komodo-components-react';
import React from 'react';
import './Search.scss';

interface SearchProps {
  handleKeyUp: (event: React.KeyboardEvent<any>) => void;
  keywordHandler: (query: string) => void;
  handleOnClearSearch: () => void;
  searchRef: React.RefObject<HTMLCoreSearchElement>;
  searchHandler: () => void;
}

const Search: React.FC<SearchProps> = ({ searchHandler, handleKeyUp, keywordHandler, handleOnClearSearch, searchRef }) => {
  return (
    <div className="searchv2">
      <CoreSearch
        data-testid="header-search-bar"
        id="search-bar"
        onKeyUp={(event) => handleKeyUp(event)}
        placeholder="Search by using asset name, type or ID"
        clearicon
        bold
        onSearchEnterPress={() => searchHandler()}
        onSearchQueryChanged={(event) => keywordHandler(event.detail)}
        onSearchCleared={handleOnClearSearch}
        ref={searchRef}></CoreSearch>
      <div
        className="search-icon-wrapper"
        onClick={() => { }}
        title="Search button"
        data-testid="header-search-icon">
        <span className={'icon-24-search-mono '} />
      </div>
    </div>
  );
};

export default Search;
